import { IBusLocation, IBusStopEvent } from "./lineInfo.types";

export class BusLocation implements IBusLocation {
  readonly allocUid: string;
  readonly lineTurnUid: string;
  readonly lineRouteUid: string;
  readonly lineTypeCode: string;
  readonly totalSeatsCount: number;
  readonly remainingSeatsCount: number;
  readonly boardingCount: number;
  readonly busOrder: number;
  readonly plateNumber: string;
  readonly driveDate: string;
  readonly collectedTime: string;
  readonly lat: number;
  readonly lng: number;
  readonly bearing: number | undefined;
  readonly driverEventCode?: string;
  readonly driverEventName?: string;
  readonly allocStatusCode?: string;
  readonly busStopEvents: Array<IBusStopEvent>;
  readonly nextStopName: string;

  constructor(data: IBusLocation) {
    this.allocUid = data.allocUid;
    this.lineTurnUid = data.lineTurnUid;
    this.lineRouteUid = data.lineRouteUid;
    this.lineTypeCode = data.lineTypeCode;
    this.totalSeatsCount = data.totalSeatsCount;
    this.remainingSeatsCount = data.remainingSeatsCount;
    this.boardingCount = data.boardingCount;
    this.busOrder = data.busOrder;
    this.plateNumber = data.plateNumber;
    this.driveDate = data.driveDate;
    this.collectedTime = data.collectedTime;
    this.lat = data.lat;
    this.lng = data.lng;
    this.driverEventCode = data.driverEventCode;
    this.driverEventName = data.driverEventName;
    this.allocStatusCode = data.allocStatusCode;
    this.busStopEvents = data.busStopEvents;
    this.bearing = data.bearing;
    this.nextStopName = data.nextStopName;
  }
}
